import React from "react"
import TextField, { TextFieldProps, TextFieldVariants } from "@mui/material/TextField"

const MuiTextField = <Variant extends TextFieldVariants>(
    props: {
        variant?: Variant
    } & Omit<TextFieldProps, "variant">
) => {
    const { error, sx = {}, ...rest } = props

    return (
        <TextField
            size="small"
            variant="standard"
            sx={{
                border: error ? "1px solid #F94054" : undefined,
                ".Mui-disabled:before": {
                    borderBottom: "none !important",
                },
                ...sx,
            }}
            {...rest}
        />
    )
}

export default MuiTextField
